// extracted by mini-css-extract-plugin
export var icon = "_qv-0";